import { routineRunSchema, routineRunStatusSchema, routineTriggerSchema, } from '#src/routines/routines.contract.js';
import { definePolicy, listQuerySchema } from '#src/rsql/index.js';
/** O que `GET /api/routines/:name/runs` deixa filtrar, ordenar e pedir. */
export const routineRunsPolicy = definePolicy({
    fields: {
        id: { type: 'uuid' },
        trigger: { type: 'enum', values: routineTriggerSchema.options },
        status: {
            type: 'enum',
            values: routineRunStatusSchema.options,
            sortable: true,
        },
        scheduledFor: { type: 'datetime', sortable: true },
        startedAt: { type: 'datetime', sortable: true },
        finishedAt: { type: 'datetime', sortable: true },
        error: { type: 'string', wildcards: true, caseInsensitive: true },
        'requestedBy.email': {
            type: 'string',
            wildcards: true,
            caseInsensitive: true,
        },
    },
    defaultSort: [{ field: 'startedAt', direction: 'desc' }],
    selectable: routineRunSchema.keyof().options,
});
export const routineRunsQuerySchema = listQuerySchema(routineRunsPolicy);
//# sourceMappingURL=routine-runs.policy.js.map